// extracted by mini-css-extract-plugin
export default {"btn":"CustomButton_btn__kQ6Ld","text":"CustomButton_text__eWWZ3"};